import { GridCellParams } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { ComponentName, getMetaData } from '../../Compounds/DetailsDrawer/detailsDrawersHelpers';
import { DetailCTARenderer } from '../../Compounds/UpstackDataGrid/CellRenderers';
import { PaymentRecipient } from '../../../store/PaymentRecipient';
import { GridCustomColDef } from '../../types';
import { getDate, getFormattedDate } from '../../../utils/helpers';

export const DefaultRecipientGridColumnDefs: GridCustomColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    renderCell: (params: GridCellParams<PaymentRecipient>) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.PAYMENT_RECIPIENT, id: params.row.id, data: params.row })
        }}
      />
    ),
    hideable: false,
    pinned: 'left',
    disableReorder: true
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: true,
    filterable: true,
    width: 200,
    flex: 1,
    description: 'Drag to move column'
  },
  {
    field: 'type',
    headerName: 'Type',
    sortable: true,
    filterable: true,
    width: 150,
    flex: 1,
    description: 'Drag to move column'
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    sortable: true,
    filterable: true,
    width: 200,
    flex: 1,
    description: 'Drag to move column',
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    valueGetter: (value) => {
      return value ? getDate(value).getTime() : '';
    },
    hideByDefault: true
  },
  {
    field: 'createdBy.name',
    headerName: 'Created By',
    sortable: true,
    filterable: true,
    width: 170,
    flex: 1,
    hideByDefault: true,
    description: 'Drag to move column',
    renderCell: (params: GridCellParams) => (
      <span title={params.row.createdBy?.email || ''}>{params.value as string}</span>
    ),
    valueGetter: (_value, row) => `${row?.createdBy?.firstName || ''} ${row?.createdBy?.lastName || ''}`
  }
];
